import { DetailsPanel } from '@/components/controls';
import { useOptions } from '@/hooks';

export function Attributes({ properties }) {
  const {
    query: { data: attributes },
  } = useOptions('objectiveAttribute');

  if (!attributes || attributes.length === 0) {
    return null;
  }

  return (
    <DetailsPanel
      entries={attributes.map(({ value, label, values }) => ({
        label,
        value:
          values?.find((v) => v.value === properties[value])?.label ??
          properties[value] ??
          '',
      }))}
    />
  );
}
